import axios from "axios"

// Real backend: the sam reducer surfaces a degraded UX on _FAILURE.
function getSamContext({ id }) {
    return axios.get(`api/v1/activities/${id}/sam-context`)
}

function sendSamMessage({ activity_id }, body) {
    return axios.post(`api/v1/activities/${activity_id}/sam/conversation`, body)
}

// D-1 — intermediate "show me where I stand" photo (quali only).
function requestSamWorkCheck({ activityId }, formData, urlParams, onUploadProgress) {
    return axios.post(`api/v1/student/activities/${activityId}/sam-work-check`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
    })
}

export const samService = {
    getSamContext,
    sendSamMessage,
    requestSamWorkCheck,
}
